import { render, staticRenderFns } from "./ReportLayette.vue?vue&type=template&id=2f394944"
import script from "./ReportLayette.vue?vue&type=script&lang=js"
export * from "./ReportLayette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports